export const clients = "newClients";
export const products = "newProducts";
export const contactus = "newContactUs";
export const jumbotron = "newJumbotron";
export const InfoArea = "newInfoArea";
export const services = "newServices";
